import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-white/10 bg-[#050505] mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 border border-[#E6C998] flex items-center justify-center">
              <span className="font-display text-[#E6C998] text-lg leading-none">M</span>
            </div>
            <div className="font-display text-xl text-white">Madrefajona Reserved</div>
          </div>
          <p className="text-neutral-400 text-sm max-w-md leading-relaxed">
            {t("footer.tagline")}
          </p>
          <div className="mt-6 text-xs text-neutral-500 leading-relaxed max-w-md">
            {t("footer.disclaimer")}
          </div>
          <div className="mt-6">
            <LanguageSwitcher variant="footer" />
          </div>
        </div>
        <div>
          <div className="overline mb-4">{t("footer.platform")}</div>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li><Link to="/marketplace/crypto" className="hover:text-white">{t("nav.crypto")}</Link></li>
            <li><Link to="/marketplace/gold" className="hover:text-white">{t("nav.gold")}</Link></li>
            <li><Link to="/marketplace/stocks" className="hover:text-white">{t("nav.stocks")}</Link></li>
            <li><Link to="/marketplace/spacex" className="hover:text-white">{t("nav.spacex")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">{t("footer.firm")}</div>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li><Link to="/about" className="hover:text-white">{t("nav.about")}</Link></li>
            <li><Link to="/faq" className="hover:text-white">{t("nav.faq")}</Link></li>
            <li><Link to="/contact" className="hover:text-white">{t("nav.contact")}</Link></li>
            <li><Link to="/risk" className="hover:text-white">{t("footer.riskDisclosure")}</Link></li>
            <li><Link to="/terms" className="hover:text-white">{t("footer.terms")}</Link></li>
            <li><Link to="/privacy" className="hover:text-white">{t("footer.privacy")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} Madrefajona Reserved. {t("footer.rights")}</div>
          <div>{t("footer.registered")}</div>
        </div>
      </div>
    </footer>
  );
}
